import { useState } from 'react';
import classes from './DurationSelector.module.css';
import PropTypes from 'prop-types';
import Input from 'Components/Atoms/Input/Input';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const ALLOWED_KEYS = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    '.',
];

export default function DurationSelector(props) {
    const { value: initialValue, onChange, options, className, periodicity } = props;

    const [otherTaxValue, setOtherTaxValue] = useState(() => {
        if (initialValue == null) return '';

        const vatOption = options.find((option) => option.id === initialValue);
        if (vatOption) return '';

        return initialValue;
    });

    const { t } = useTranslation('forecasts');

    const handleOtherTaxChange = (ev) => {
        const { value } = ev.target;
        setOtherTaxValue(value);

        if (value === '') {
            onChange(null);
            return;
        }

        const numberValue = Number(value);

        if (!Number.isNaN(numberValue)) {
            onChange(Math.max(numberValue * -1, -30));
        }
    };

    const handleTaxChange = (value) => {
        setOtherTaxValue('');

        const normalizedValue = value === initialValue ? null : value;
        onChange(normalizedValue);
    };

    const handleKeyDown = (ev) => {
        const { key } = ev;
        const isNumber = !Number.isNaN(Number(key));
        const isAllowedKey = ALLOWED_KEYS.includes(key);

        if (!isNumber && !isAllowedKey) {
            ev.preventDefault();
        }
    };

    const PERIODICITY_LABELS = {
        daily: t('days'),
        weekly: t('weeks'),
        monthly: t('months'),
        quarterly: t('quarters'),
        yearly: t('years'),
    };

    const suffix = PERIODICITY_LABELS[periodicity] || PERIODICITY_LABELS.monthly;

    return (
        <div className={clsx('flex flex-wrap gap-2', className)}>
            {options.map((vatOption) => (
                <button
                    key={vatOption.id}
                    type="button"
                    className={clsx(classes.toggleButton, 'grow')}
                    onClick={() => handleTaxChange(vatOption.id)}
                    aria-pressed={otherTaxValue === '' && vatOption.id === initialValue}
                >
                    {vatOption.label}
                </button>
            ))}

            <Input
                className={clsx(classes.otherInput, otherTaxValue !== '' && classes.inputActive)}
                value={otherTaxValue}
                onChange={handleOtherTaxChange}
                onFocus={() => onChange(null)}
                onKeyDown={handleKeyDown}
                placeholder={t('other')}
                suffix={suffix}
            />
        </div>
    );
}

DurationSelector.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        }),
    ).isRequired,
    periodicity: PropTypes.string.isRequired,
    className: PropTypes.string,
};
